import ColorByStatus from './ColorByStatus'

function ProceedingType({ value }) {
  const typeMessages = {
    e: 'Estampilla',
    b: 'BUS',
  }
  const error = ['c', 'i', 'w', 'r'].includes(value)
  // console.log('ProceedingType', value)
  return typeMessages[value] || 'Tipo ' + value
}

export default ProceedingType
